/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["th{text-transform:capitalize!important}h1 div{font-size:28px;font-weight:400}.round-card{background:#fff;margin-bottom:0;border:1px solid #eee;padding:5px;border-radius:1rem!important;display:flex}.child{padding:2px;display:block;margin-right:10px}.child-count{font-size:16px;font-weight:500}.child-subtitle{font-size:14px;font-weight:400}@media (max-width:720px){.child{position:relative;display:block;width:100%}}"];
export { styles as styles };
